// Flickity custom navigation for USP Slim slider, with Shopify customizer support and responsive resize handling
function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

function initSliderQuote(container = document) {
  container
    .querySelectorAll(".slider-quote--container")
    .forEach(function (slider) {
      const existingFlkty = Flickity.data(slider);

      // Above breakpoint: destroy if initialized, then skip init
      if (window.innerWidth > 1024) {
        if (existingFlkty) {
          existingFlkty.destroy();
        }
        return;
      }

      // Below breakpoint: re-init if necessary
      if (existingFlkty) {
        existingFlkty.destroy();
      }

      new Flickity(slider, {
        cellAlign: "center",
        contain: true,
        pageDots: true,
        prevNextButtons: false,
      });
    });
}

// Init on page load
document.addEventListener("DOMContentLoaded", function () {
  initSliderQuote();

  // Responsive resize support
  window.addEventListener(
    "resize",
    debounce(function () {
      initSliderQuote();
    }, 200)
  );

  // Shopify theme editor support
  document.addEventListener("shopify:section:load", function (event) {
    initSliderQuote(event.target);
  });
});
